import {
  useSortable,
  UseSortableArguments,
} from '@wix/patterns-dnd-kit-sortable';

export function useSortableTableRow({
  id,
  disabled,
}: {
  id: string | number;
  disabled?: UseSortableArguments['disabled'];
}) {
  return useSortable({
    id,
    transition: {
      duration: 250,
      easing: 'cubic-bezier(0.33, 1, 0.68, 1)',
    },
    disabled,
  });
}
